// extracted by mini-css-extract-plugin
module.exports = {"container":"EO","noResults":"FO","contact":"GO"};